import styles from './Inventory.module.css'

type Props = {
  count?: number
}

/** Placeholder layout matching the product card grid while the first list request is in flight. */
export function InventoryProductsSkeleton({ count = 6 }: Props) {
  const n = Math.max(1, Math.min(12, count))
  return (
    <div className={styles.productsList} aria-busy="true" aria-label="Loading inventory list">
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} className={styles.productCardSkeleton}>
          <div className={`${styles.skeletonBlock} ${styles.skeletonCheckbox}`} />
          <div className={`${styles.skeletonBlock} ${styles.skeletonImage}`} />
          <div className={styles.skeletonDetails}>
            <div className={`${styles.skeletonBlock} ${styles.skeletonLineLg}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLineSm}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLineSm}`} />
          </div>
          <div className={styles.skeletonInventory}>
            <div className={`${styles.skeletonBlock} ${styles.skeletonLineMd}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLineMd}`} />
          </div>
          <div className={styles.skeletonActions}>
            <div className={`${styles.skeletonBlock} ${styles.skeletonPill}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonPill}`} />
          </div>
        </div>
      ))}
    </div>
  )
}
